import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { LocalStorage } from '@core/browser';
import { SHARE_KEY_HEADER } from '@core/data/types/advanced-report';

@Injectable()
export class ReportHttpHelperService {

    constructor(private _storage: LocalStorage) {}

    /**
     * Appends the X-Share-Key header to any existing HTTP options.
     */
    public withShareKey(existingOptions: any = {}, shareKey: string = null): { headers: HttpHeaders, [key: string]: any } {

        let headers = existingOptions.headers instanceof HttpHeaders
            ? existingOptions.headers
            : new HttpHeaders(existingOptions.headers || {});

        if (shareKey) {
            headers = headers.set(SHARE_KEY_HEADER, shareKey);
        }

        return {
            ...existingOptions,
            headers: headers
        };
    }
}